var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-configurator-tablist" }, [
    _c("h2", { staticClass: "nti-configurator-tablist__title" }, [
      _vm._v(_vm._s(_vm.verifyLabel("configuratorTitle"))),
    ]),
    _vm._v(" "),
    !_vm.canBeBought
      ? _c(
          "a",
          {
            staticClass: "link-button btn btn-primary smooth-scroll",
            attrs: { href: "#block-callform" },
          },
          [_vm._v("Kontakt oss for tilbud")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canBeBought
      ? _c(
          "div",
          [
            !_vm.hasSingleLicenseType && !_vm.isHardware
              ? _c(
                  "section",
                  {
                    staticClass:
                      "nti-configurator-tablist__tab nti-configurator-tablist__tab--underline",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "nti-configurator-tablist__subtitle" },
                      [_vm._v(_vm._s(_vm.verifyLabel("levelOneLabel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nti-configurator-tablist__tab-container",
                      },
                      [
                        _vm._l(_vm.LevelOne, function (data) {
                          return [
                            _c(
                              "button",
                              {
                                key: data.id,
                                staticClass:
                                  "nti-button nti-configurator-tablist__tab__link",
                                class: {
                                  "nti-button--selected":
                                    _vm.selectedLevelOne === data.id,
                                },
                                attrs: {
                                  "aria-label": "Select location",
                                  role: "tab",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.activateLevelOne(data.id)
                                  },
                                },
                              },
                              [
                                _vm.selectedLevelOne === data.id
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "nti-svg__container-medium nti-svg__container-medium--checkmark",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 512 512",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(data.displayName))]),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              !_vm.isHardware
                ? _c(
                    "section",
                    {
                      staticClass:
                        "nti-configurator-tablist__tab nti-configuration-tablist__tabcontent",
                      class: {
                        "nti-configurator-tablist__tab--underline":
                          _vm.selectedLevelOne,
                      },
                      attrs: { role: "tabpanel" },
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "nti-configurator-tablist__subtitle" },
                        [_vm._v(_vm._s(_vm.verifyLabel("levelTwoLabel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "nti-configurator-tablist__tab-container",
                        },
                        [
                          _vm._l(_vm.LevelTwoData, function (data) {
                            return [
                              _c(
                                "button",
                                {
                                  key: data.id,
                                  staticClass:
                                    "nti-button nti-configurator-tablist__tab__link",
                                  class: {
                                    "nti-button--selected":
                                      _vm.selectedLevelTwo === data.id,
                                  },
                                  attrs: {
                                    "aria-label": "Select date",
                                    role: "tab",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.chooseLevelTwo(
                                        data.id,
                                        data.name
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.selectedLevelTwo === data.id
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "nti-svg__container-medium nti-svg__container-medium--checkmark",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 512 512",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(data.displayName) +
                                        " " +
                                        _vm._s(data.labelName)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "section",
                {
                  staticClass: "nti-configurator-tablist__tab",
                  class: {
                    "nti-configurator-tablist__tab--underline":
                      _vm.selectedLevelTwo || _vm.isHardware,
                  },
                  attrs: { role: "tabpanel" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "nti-configurator-tablist__subtitle",
                      attrs: { for: "amount-input-field" },
                    },
                    [_vm._v(_vm._s(_vm.verifyLabel("levelThreeLabel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nti-configurator-tablist__tab-container" },
                    [
                      _vm.showNextRow
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "plus-minus-selector nti-configurator-tablist__plus-minus",
                              },
                              [
                                _c("button", {
                                  staticClass:
                                    "plus-minus-selector__btn plus-minus-selector__btn--minus",
                                  attrs: {
                                    href: "#",
                                    "aria-label": "Subtract product",
                                  },
                                  on: { click: _vm.decrementAmount },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.amount,
                                      expression: "amount",
                                    },
                                  ],
                                  staticClass:
                                    "nti-configurator-tablist__plus-minus__input",
                                  attrs: {
                                    id: "amount-input-field",
                                    name: "product-amount",
                                    type: "number",
                                  },
                                  domProps: { value: _vm.amount },
                                  on: {
                                    change: _vm.changeAmount,
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.amount = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("button", {
                                  staticClass:
                                    "plus-minus-selector__btn plus-minus-selector__btn--plus",
                                  attrs: {
                                    href: "#",
                                    "aria-label": "Add product",
                                  },
                                  on: { click: _vm.incrementAmount },
                                }),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.showNextRow
              ? [
                  _c(
                    "section",
                    { staticClass: "nti-configurator-tablist__add-to-cart" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "nti-configurator-tablist__add-to-cart__wrapper",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "nti-configurator-tablist__add-to-cart__price-text",
                            },
                            [_vm._v(_vm._s(_vm.verifyLabel("priceLabel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "nti-configurator-tablist__add-to-cart__price-container",
                            },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "nti-configurator-tablist__add-to-cart__total-price",
                                  class: {
                                    "nti-configurator-tablist__add-to-cart__total-price--discount":
                                      _vm.productHasDiscount,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.priceText))]
                              ),
                              _vm._v(" "),
                              _vm.productHasDiscount
                                ? _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "nti-configurator-tablist__add-to-cart__total-price",
                                    },
                                    [_vm._v(_vm._s(_vm.priceDiscountedText))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "nti-configurator-tablist__add-to-cart__label",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.verifyLabel(
                                        "exVatAndHandlingFeeLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "nti-button nti-button--confirm pardotTrackClick",
                          attrs: { disabled: !_vm.allIsSelected },
                          on: { click: _vm.addToCart },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "nti-svg__container-medium nti-svg--add-to-cart",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    viewBox: "0 0 22 16",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Symbols",
                                        stroke: "none",
                                        "stroke-width": "1",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "HEADER",
                                            transform:
                                              "translate(-1314.000000, -33.000000)",
                                            "fill-rule": "nonzero",
                                          },
                                        },
                                        [
                                          _c("g", { attrs: { id: "Shape" } }, [
                                            _c("path", {
                                              attrs: {
                                                d: "M1322.88889,47.6666667 C1322.88889,48.4035556 1322.29156,49 1321.55556,49 C1320.81956,49 1320.22222,48.4035556 1320.22222,47.6666667 C1320.22222,46.9306667 1320.81956,46.3333333 1321.55556,46.3333333 C1322.29156,46.3333333 1322.88889,46.9306667 1322.88889,47.6666667 Z M1326,46.3333333 C1325.264,46.3333333 1324.66667,46.9297778 1324.66667,47.6666667 C1324.66667,48.4035556 1325.264,49 1326,49 C1326.736,49 1327.33333,48.4035556 1327.33333,47.6666667 C1327.33333,46.9306667 1326.736,46.3333333 1326,46.3333333 Z M1316.61067,41.8888889 L1314,35.6666667 L1328.944,35.6666667 L1327.18667,41.8888889 L1316.61067,41.8888889 Z M1326.59556,37.4444444 L1316.67378,37.4444444 L1317.79289,40.1111111 L1325.84267,40.1111111 L1326.59556,37.4444444 Z M1331.60444,33 L1328.55378,43.6666667 L1317.35644,43.6666667 L1318.10222,45.4444444 L1329.87022,45.4444444 L1332.95822,34.7777778 L1334.67289,34.7777778 L1335.33333,33 L1331.60444,33 Z",
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.verifyLabel("addToBasket")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }